import React, { useEffect, useState } from 'react';

import { Button, Form } from 'antd';
import { AuthUseCaseInterface } from 'application/usecases/AuthUseCase';
import Logo from 'assets/images/LogoIconAndTextHorizontal.svg';
import { openErrorNoti, openSuccessNoti } from 'presentation/components/Notification';
import { setDisabledBTN } from 'presentation/redux/features/CU/CU03101Slice';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { AUTH_ROUTES } from 'presentation/router/CONSTANTS';
import { useLocation, useNavigate } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';
import { InputNewPassword } from './components/InputNewPassword';
import { InputOTP } from './components/InputOTP';

interface props {
    authUseCase: AuthUseCaseInterface;
}

const CU02701Page = ({ authUseCase }: props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const [showTimer, setShowTimer] = useState(false);
    const [otp, setOtp] = useState('');
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [form] = Form.useForm();

    useEffect(() => {
        if (location.state?.email) {
            setEmail(location.state.email);
        } else {
            navigate(AUTH_ROUTES.PATH + '/' + AUTH_ROUTES.SUB.CU_026_01);
        }
    }, []);

    const [isDisabled, setIsDisabled] = React.useState<boolean>(true);

    const onChange = (value: string) => {
        setOtp(value);
        setErrorMessage('');
        validateForm(value?.trim());
    };

    const reSendOtp = async () => {
        try {
            const payload = {
                email: email,
            };
            setOtp('');
            setErrorMessage('');
            setDisabledBTN(true);
            dispatch(startFetching());
            const response = await authUseCase.verifyEmail(payload);
            if (response && response.status == '200') {
                setShowTimer(true);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const submit = async (value: any) => {
        try {
            const payload = {
                email: email,
                otp: otp,
                password: value.password,
            };
            dispatch(startFetching());
            const response = await authUseCase.resetPassword(payload);
            if (response && response.status == '200') {
                openSuccessNoti({ description: getMessage('I0135') });
                navigate(AUTH_ROUTES.PATH + '/' + AUTH_ROUTES.SUB.CU_001_04);
            } else {
                setErrorMessage(response?.result?.message);
            }
        } catch (error: any) {
            setErrorMessage(error.result.message);
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const validateForm = (otpValue: string) => {
        form.validateFields({
            validateOnly: true,
        })
            .then(() => {
                setIsDisabled(otpValue.length < 6);
            })
            .catch((err) => {
                setIsDisabled(err.errorFields.length > 0 || otpValue.length < 6);
            });
    };

    return (
        <section
            className="width-full-screen center-inside CU-001-04-container"
            style={{
                height: '100vh',
            }}
        >
            <div style={{ width: 343 }}>
                <div
                    className="center-inside center"
                    style={{ borderRadius: 100, backgroundColor: '#fff', width: 160, height: 160 }}
                >
                    <img alt="logo" src={Logo} className='logo'/>
                </div>
                <Form
                    onFinish={submit}
                    form={form}
                    onValuesChange={() => {
                        validateForm(otp);
                    }}
                >
                    <InputOTP
                        errMessage={errorMessage}
                        otp={otp}
                        onChange={onChange}
                        reSendOtp={reSendOtp}
                        showTimer={showTimer}
                        setShowTimer={setShowTimer}
                    />
                    <InputNewPassword />
                    <Button
                        className="button-login-text"
                        type="primary"
                        style={{ width: '100%', height: 56, marginTop: 16 }}
                        disabled={isDisabled}
                        htmlType="submit"
                    >
                        再設定
                    </Button>
                </Form>
            </div>
        </section>
    );
};
export default CU02701Page;
